import cookies from 'js-cookie';
import { formatCookieDomain } from './domainParser';

const POST_CODE_COOKIE_NAME = 'pc';
const POST_CODE_COOKIE_EXPIRE = 365;

export const getUserPostcode = (): string => cookies.get(POST_CODE_COOKIE_NAME);

export const setUserPostcode = (postcode = '') => {
  cookies.set(POST_CODE_COOKIE_NAME, postcode, {
    expires: POST_CODE_COOKIE_EXPIRE,
    path: '/',
    domain: formatCookieDomain(document.location.hostname),
  });
};
